import { PoolType } from '@fd/common/api/fetchProxyPool';
import { ProxyServerType } from '@fd/common/biz/proxyType';

export default function formatProxies(
  proxies: ProxyServerType[],
  pool: PoolType,
  format: string
) {
  return proxies
    .map((proxy) =>
      format
        .toLowerCase()
        .replace('hostname', proxy.host)
        .replace('port', proxy.port.toString())
        .replace('username', proxy.username)
        .replace('password', proxy.password)
        .replace('protocol', pool.protocol.length > 0 ? pool.protocol : 'http')
    )
    .join('\n');
}
